import { observer } from 'mobx-react-lite'
import { useEventCallEnded } from 'entities/Call/events/EventCallEnded'
import { useEventCallTransferFailed } from 'entities/Call/events/EventCallTransferFailed'
import { useEventCallTransferSucceeded } from 'entities/Call/events/EventCallTransferSucceeded'
import { globalEventsRegistry } from 'app/shared/ui/GlobalEvents/store/globalEventsRegistry'

const lightEventsEnabled = () => !globalEventsRegistry.hasFullEvents

export const GlobalLightEvents = observer(() => {
  useEventCallEnded({ enabled: lightEventsEnabled })
  useEventCallTransferFailed({ enabled: lightEventsEnabled })
  useEventCallTransferSucceeded({ enabled: lightEventsEnabled })

  return null
})
